import { useTreasureApi, ApiKeys } from 'hooks/api/use-treasure-api';
import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import { ReactQueryKeys } from 'enums';

export const useCreateScheduleTransfer = (): UseMutationResult<
  any,
  any,
  any
> => {
  const queryClient = useQueryClient();

  const { treasureApi } = useTreasureApi(ApiKeys.PortalGateway);

  const createScheduleTransfer = async ({
    amountDollars,
    bankAccountId,
    direction,
    frequency,
    idempotencyKey,
    startDate,
  }: {
    /** Decimal dollars. $1 is 1 or "1.00", not 100. */
    amountDollars: string | number;
    bankAccountId: string;
    direction: string;
    frequency: string;
    idempotencyKey: string;
    startDate: string;
  }) => {
    // Wire field stays `amount`. Unit is decimal dollars, not cents.
    const response = await treasureApi().post('/transfer/schedule', {
      amount: amountDollars,
      bankAccountId,
      direction,
      frequency,
      idempotencyKey,
      startDate,
    });

    return response.data;
  };

  return useMutation(createScheduleTransfer, {
    onSuccess: () => {
      // TODO: remove old DashboardActivity
      queryClient.invalidateQueries([ReactQueryKeys.DashboardActivity]);
      queryClient.invalidateQueries([ReactQueryKeys.DashboardActivityGateway]);
      return queryClient.invalidateQueries([ReactQueryKeys.ScheduleTransfers]);
    },
  });
};
